export const APP_NAME = 'Sistema IT Arkon';
export const PERSIST_STORE_NAME = 'portal';
export const REDIRECT_URL_KEY = 'redirectUrl';
